// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3-e-L","colCheckbox":"styles_colCheckbox__JY0Fk"};